module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yo-scroll",
    class: {
      'down': (_vm.state === 0), 'up': (_vm.state == 1), refresh: (_vm.state === 2), touch: _vm.touching
    },
    on: {
      "touchstart": function($event) {
        _vm.touchStart($event)
      },
      "touchmove": function($event) {
        _vm.touchMove($event)
      },
      "touchend": function($event) {
        _vm.touchEnd($event)
      },
      "scroll": function($event) {
        (_vm.onInfinite || _vm.infiniteLoading) ? _vm.onScroll($event): undefined
      }
    }
  }, [_c('div', {
    staticClass: "inner",
    style: ({
      transform: 'translate3d(0, ' + _vm.top + 'px, 0)'
    })
  }, [_c('header', {
    staticClass: "pull-refresh"
  }, [_vm._t("pull-refresh", [_c('span', {
    staticClass: "down-tip"
  }, [_vm._v("下拉加载更多")]), _vm._v(" "), _c('span', {
    staticClass: "up-tip"
  }, [_vm._v("松开加载")]), _vm._v(" "), _c('span', {
    staticClass: "refresh-tip"
  }, [_vm._v("加载中")])])], 2), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8c855c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sroll.vue
// module id = LwRI
// module chunks = 6